/**
 * Include your custom JavaScript here.
 */

function mediaThumbnail(index) {
  var mobileNav = document.querySelector('.Product__SlideshowMobileNav');
  var dots = mobileNav ? mobileNav.querySelectorAll('.dot') : [];

  if (dots[index]) {
    dots[index].click();
    return;
  }

  var slideshow = document.querySelector('.Product__Slideshow');
  var flickityInstance = window.Flickity && slideshow ? window.Flickity.data(slideshow) : null;

  if (flickityInstance) {
    flickityInstance.select(index);
    return;
  }

  var slide = slideshow ? slideshow.querySelectorAll('.Product__SlideItem')[index] : null;
  if (slide) {
    slide.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
  }
}

function getFrameKey(name) {
  return String(name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, '_')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

function getCanonicalFrameKeys(name) {
  var raw = getFrameKey(name);
  var tokens = raw.split('_').filter(Boolean);
  var has = function(values) {
    return values.some(function(value) { return tokens.indexOf(value) !== -1; });
  };

  var family = '';
  if (has(['minimal'])) family = 'minimal';
  else if (has(['century'])) family = 'century';
  else if (has(['gallery', 'galery', 'galeri', 'lienzo'])) family = 'gallery';

  var color = '';
  if (has(['negro', 'black', 'noir', 'schwarz', 'preto'])) color = 'negro';
  else if (has(['blanco', 'white', 'blanc', 'weiss', 'wei', 'branco'])) color = 'blanco';
  else if (has(['nogal', 'walnut', 'noyer', 'walnuss', 'nogueira'])) color = 'nogal';
  else if (has(['madera', 'roble', 'wood', 'oak', 'bois', 'chene', 'eiche', 'holz', 'madeira', 'carvalho'])) color = 'roble';

  var keys = [raw];
  if (family && color) {
    keys.push(family + '_marco_' + color);
    // The historical technical key remains valid while Madera and Roble coexist.
    if (color === 'roble') keys.push(family + '_marco_madera');
  }

  return keys.filter(function(key, index, array) {
    return key && array.indexOf(key) === index;
  });
}

function findFrameImage(name) {
  var keys = getCanonicalFrameKeys(name);
  var selectedImage = null;

  for (var i = 0; i < keys.length && !selectedImage; i++) {
    selectedImage = document.getElementById('img_' + keys[i]);
  }

  if (selectedImage) return selectedImage;

  var frameImages = document.getElementsByClassName('frame-image');
  for (var j = 0; j < frameImages.length; j++) {
    var image = frameImages[j];
    var candidates = [];
    if (image.dataset.frameKey) candidates.push(image.dataset.frameKey);
    if (image.dataset.frameAliases) {
      candidates = candidates.concat(image.dataset.frameAliases.split('|'));
    }

    var normalizedCandidates = candidates.map(getFrameKey).filter(Boolean);
    for (var k = 0; k < keys.length; k++) {
      if (normalizedCandidates.indexOf(keys[k]) !== -1) return image;
    }
  }

  return null;
}

function changeFrame(name) {
  var frameImages = document.getElementsByClassName('frame-image');

  for (var i = 0; i < frameImages.length; i++) {
    frameImages[i].style.display = 'none';
  }

  var selectedImage = findFrameImage(name);
  if (selectedImage) {
    selectedImage.style.display = 'block';
    mediaThumbnail(0);
  }
}

function myFunction() {
  var dots = document.getElementById('dots');
  var moreText = document.getElementById('more');
  var btnText = document.getElementById('myBtn');
  if (!dots || !moreText || !btnText) return;

  if (dots.style.display === 'none') {
    dots.style.display = 'inline';
    btnText.innerHTML = 'Leer más';
    moreText.style.display = 'none';
  } else {
    dots.style.display = 'none';
    btnText.innerHTML = 'Leer menos';
    moreText.style.display = 'inline';
  }
}

function openModal13() {
  var modal = document.getElementById('myModal13');
  if (modal) modal.style.display = 'block';
}

function closeModal13() {
  var modal = document.getElementById('myModal13');
  if (modal) modal.style.display = 'none';
}

function updateCartCount() {
  if (window.KDKThemeV3 && window.KDKThemeV3.cart) return window.KDKThemeV3.cart.refresh();
  // Keep a safe compatibility path if the optional coordinator cannot load.
  var route = window.routes && window.routes.cartUrl || '/cart';
  return fetch(route.replace(/\/$/, '') + '.js', {credentials: 'same-origin'})
    .then(function(response) { if (!response.ok) throw new Error('Cart response not ok'); return response.json(); })
    .then(function(cart) {
      if (typeof cart.item_count === 'number') document.querySelectorAll('.cart-count').forEach(function(node) { node.textContent = cart.item_count; });
    }).catch(function() {});
}

function initZoomModal() {
  var modal = document.getElementById('myModal12');
  var img = document.getElementById('imgzoom');
  var span = document.getElementsByClassName('close-zoom')[0];

  if (!modal || !img || !span || img.dataset.zoomBound === 'true') {
    return;
  }

  img.dataset.zoomBound = 'true';
  img.addEventListener('click', function() {
    modal.style.display = 'block';
  });

  span.addEventListener('click', function() {
    modal.style.display = 'none';
  });
}

function initFloatingAddToCart() {
  var floatingBtn = document.getElementById('floatingAddToCart');
  var mainAddToCartBtn = document.querySelector('.ProductForm__Variants');

  if (!floatingBtn || !mainAddToCartBtn || floatingBtn.dataset.kdkBound === 'true') {
    return;
  }

  floatingBtn.dataset.kdkBound = 'true';

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      floatingBtn.style.display = entry.isIntersecting ? 'none' : 'block';
    });
  }, {
    root: null,
    threshold: 0
  });

  observer.observe(mainAddToCartBtn);

  floatingBtn.addEventListener('click', function() {
    mainAddToCartBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}

function initSelectedFrameVariant(root) {
  var scope = root || document;
  var forms = [];

  if (scope.matches && scope.matches('.ProductForm__Variants')) {
    forms.push(scope);
  }

  scope.querySelectorAll('.ProductForm__Variants').forEach(function(form) {
    forms.push(form);
  });

  if (!forms.length) {
    forms = [scope];
  }

  forms.forEach(function(form) {
    // Solo option 1 / enmarcación. La clase .frame-variants también se usa en otros grupos
    // de opciones, así que no debe usarse para inicializar el marco.
    var input = form.querySelector('.variant-frame input[type="radio"]:checked, input[type="radio"][onclick*="changeFrame"]:checked');

    if (input) {
      changeFrame(input.value);
    }
  });
}

function initCustomThemeEnhancements(root) {
  initSelectedFrameVariant(root || document);
  initZoomModal();
  initFloatingAddToCart();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initCustomThemeEnhancements(document);
    if (window.KDKThemeV3 && window.KDKThemeV3.cart) window.KDKThemeV3.cart.paint();
  });
} else {
  initCustomThemeEnhancements(document);
  if (window.KDKThemeV3 && window.KDKThemeV3.cart) window.KDKThemeV3.cart.paint();
}

/* KDK-PERF V3: cart events are coordinated once by kdk-cart-count-v3.js. */

document.addEventListener('shopify:section:load', function(event) {
  initCustomThemeEnhancements(event.target);
});



/* KDK-PERF V3 — one scheduled read/write cycle per product thumbnail rail. */
(function () {
  'use strict';
  var states = new Map();
  var api = window.KDKThemeV3 = window.KDKThemeV3 || {};
  api.thumbStats = api.thumbStats || { cycles: 0, heightWrites: 0 };
  function init(root) {
    var containers = Array.from((root || document).querySelectorAll('[data-product-mobile-thumbs]'));
    if (root && root.matches && root.matches('[data-product-mobile-thumbs]')) containers.unshift(root);
    containers.forEach(function (container) {
      if (states.has(container)) return;
      var gallery = container.closest('.Product__Gallery');
      var slideshow = gallery && gallery.querySelector('.Product__Slideshow');
      if (!slideshow) return;
      var frame = 0, bindingFrame = 0, disposed = false, instance = null, observedViewport = null;
      var ro = null, mo = null, disposers = [];
      var wantedIndex = null, shouldScroll = false;
      function listen(target, name, handler, options) {
        target.addEventListener(name, handler, options);
        disposers.push(function () { target.removeEventListener(name, handler, options); });
      }
      function schedule() {
        if (!disposed && !frame) frame = requestAnimationFrame(flush);
      }
      function flush() {
        frame = 0;
        if (disposed || !container.isConnected) return;
        api.thumbStats.cycles++;
        var viewport = slideshow.querySelector('.flickity-viewport');
        if (ro && viewport && viewport !== observedViewport) {
          if (observedViewport) ro.unobserve(observedViewport);
          ro.observe(viewport); observedViewport = viewport;
        }
        var selectedSlide = slideshow.querySelector('.Product__SlideItem.is-selected');
        // Read phase. Never ask for scroller geometry immediately after setting its height.
        var height = (viewport && viewport.clientHeight) || (selectedSlide && selectedSlide.clientHeight) || slideshow.clientHeight || 0;
        var nextHeight = height > 0 ? height + 'px' : container.style.maxHeight;
        var heightChanged = nextHeight && container.style.maxHeight !== nextHeight;
        var top = container.scrollTop, visibleHeight = container.clientHeight, totalHeight = container.scrollHeight;
        var targetTop = null;
        if (shouldScroll && wantedIndex !== null) {
          var selectedThumb = container.querySelector('[data-media-index="' + wantedIndex + '"]');
          if (selectedThumb) {
            var thumbTop = selectedThumb.offsetTop, thumbBottom = thumbTop + selectedThumb.offsetHeight;
            if (thumbTop < top || thumbBottom > top + visibleHeight) targetTop = Math.max(thumbTop - 8, 0);
          }
        }
        // Write phase. A height change is measured on the next frame, after layout.
        if (heightChanged) {
          container.style.maxHeight = nextHeight;
          api.thumbStats.heightWrites++;
          schedule();
          return;
        }
        container.classList.toggle('has-overflow', totalHeight > visibleHeight + 4);
        container.classList.toggle('is-start', top <= 4);
        container.classList.toggle('is-end', top + visibleHeight >= totalHeight - 4);
        shouldScroll = false;
        if (targetTop !== null) container.scrollTo({top: targetTop, behavior: 'smooth'});
      }
      function setSelected(index, scroll) {
        wantedIndex = Number(index);
        container.querySelectorAll('[data-media-index]').forEach(function (thumb) {
          var selected = Number(thumb.getAttribute('data-media-index')) === wantedIndex;
          thumb.classList.toggle('is-selected', selected);
          thumb.classList.toggle('active', selected);
          thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        shouldScroll = shouldScroll || !!scroll;
        schedule();
      }
      function select(index) {
        setSelected(index, true);
        instance = instance || (window.Flickity && window.Flickity.data(slideshow));
        if (instance) instance.select(index);
        else {
          var slide = slideshow.querySelectorAll('.Product__SlideItem')[index];
          if (slide) slide.scrollIntoView({behavior: 'smooth', inline: 'nearest', block: 'nearest'});
        }
      }
      function onClick(event) {
        var thumb = event.target.closest('[data-media-index]');
        if (!thumb || !container.contains(thumb)) return;
        event.preventDefault(); select(Number(thumb.getAttribute('data-media-index')));
      }
      function onKey(event) {
        if (event.key === 'Enter' || event.key === ' ') onClick(event);
      }
      function onSelect() { setSelected(instance.selectedIndex, true); }
      function bind(attempt) {
        bindingFrame = 0;
        if (disposed) return;
        var found = window.Flickity && window.Flickity.data(slideshow);
        if (!found) {
          if (attempt < 80) bindingFrame = requestAnimationFrame(function () { bind(attempt + 1); });
          return;
        }
        instance = found;
        instance.on('select', onSelect);
        instance.on('settle', schedule);
        disposers.push(function () { instance.off('select', onSelect); instance.off('settle', schedule); });
        setSelected(instance.selectedIndex, false);
      }
      function dispose() {
        disposed = true;
        cancelAnimationFrame(frame); cancelAnimationFrame(bindingFrame);
        if (ro) ro.disconnect(); if (mo) mo.disconnect();
        disposers.forEach(function (off) { off(); });
        container.removeAttribute('data-mobile-thumbs-ready');
        states.delete(container);
      }
      states.set(container, {dispose: dispose, schedule: schedule});
      container.setAttribute('data-mobile-thumbs-ready', 'v3');
      listen(container, 'click', onClick);
      listen(container, 'keydown', onKey);
      listen(container, 'scroll', schedule, {passive: true});
      listen(window, 'resize', schedule, {passive: true});
      listen(window, 'orientationchange', schedule, {passive: true});
      listen(window, 'load', schedule, {once: true});
      // Delegated load catches cached and newly inserted media without one listener per image.
      listen(gallery, 'load', schedule, true);
      listen(gallery, 'loadedmetadata', schedule, true);
      listen(gallery, 'loadeddata', schedule, true);
      if ('ResizeObserver' in window) {
        ro = new ResizeObserver(schedule);
        ro.observe(slideshow); ro.observe(container);
      }
      mo = new MutationObserver(function () { schedule(); });
      mo.observe(slideshow, {childList: true});
      setSelected(Number(container.getAttribute('data-initial-index')) || 0, false);
      bind(0);
    });
  }
  function unload(root) {
    states.forEach(function (state, element) { if (element === root || root.contains(element)) state.dispose(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) states.forEach(function (state) { state.schedule(); }); });
})();


/* === KDK: ocultar widgets fijos de terceros durante drawers y diálogos nativos === */
(function () {
  var PRESTIGE_DRAWERS_SELECTOR = '#sidebar-menu[aria-hidden="false"], #sidebar-cart[aria-hidden="false"]';
  var BLOCKING_UI_ATTRIBUTE = 'data-kdk-blocking-ui-open';

  var ALLOW_SELECTOR = [
    '#sidebar-menu',
    '#sidebar-cart',
    '.Drawer',
    '.PageOverlay',
    '.PageTransition',
    '.Modal',
    '.pswp',
    '.kdk-preview-overlay',
    '.kdk-preview-modal',
    '.kdk-pdp-preview__modal',
    '.kdk-native-dialog',
    '.kdk-native-filter-shell',
    '[id^="kdk-size-"]',
    '#shopify-section-header',
    '.Product__InfoWrapper',
    '.Product__Info',
    '.ProductForm',
    '.ProductForm__Variants',
    '.ProductForm__AddToCart'
  ].join(', ');

  var CONSENTMO_SELECTORS = [
    'csm-cookie-consent',
    'csm-web-accessibility',
    '#csm-ada-toggle-widget-button',
    '#csm-ada-compliance-wrapper',
    '.csm-ada-compliance-wrapper',
    '.UMVUvJnDOp3O6L2Ojugw',
    '[id^="csm-ada-"]',
    '[class*="csm-ada-"]'
  ].join(', ');

  var KNOWN_WIDGETS = [
    'molin-shop-ai',
    '.jdgm-revs-tab',
    '.jdgm-revs-tab-btn',
    '.cc-window',
    '.cc-revoke',
    'csm-cookie-consent',
    'csm-web-accessibility',
    '#csm-ada-toggle-widget-button',
    '#csm-ada-compliance-wrapper',
    '.csm-ada-compliance-wrapper',
    '.UMVUvJnDOp3O6L2Ojugw',
    '[id^="csm-ada-"]',
    '[class*="csm-ada-"]'
  ].join(', ');

  var bodyObserver = null;
  var drawerObserver = null;
  var uiStateObserver = null;
  var scanScheduled = false;
  var forcedHiddenElements = [];
  var forcedInlineState = new WeakMap();

  function prestigeDrawerIsOpen() {
    return !!document.querySelector(PRESTIGE_DRAWERS_SELECTOR);
  }

  function nativeOverlayIsOpen() {
    return document.documentElement.classList.contains('kdk-native-overlay-open');
  }

  function blockingUiIsOpen() {
    return prestigeDrawerIsOpen() || nativeOverlayIsOpen() || !!document.querySelector('.kdk-size-request:not([hidden])');
  }

  function scheduleScan() {
    if (scanScheduled) {
      return;
    }

    scanScheduled = true;

    window.requestAnimationFrame(function () {
      scanScheduled = false;
      scan();
    });
  }

  /* Permite que el buscador solicite el ocultado/restaurado en el mismo ciclo. */
  window.__kdkRefreshFloatingWidgets = scan;

  function isAllowed(el) {
    if (!el || el.nodeType !== 1) {
      return true;
    }

    return !!(el.matches(ALLOW_SELECTOR) || el.closest(ALLOW_SELECTOR));
  }

  function isPopoverOpen(el) {
    if (!el || typeof el.matches !== 'function') {
      return false;
    }

    try {
      return el.matches(':popover-open');
    } catch (error) {
      return false;
    }
  }

  function isSmallFloatingElement(rect) {
    var viewportArea = Math.max(window.innerWidth * window.innerHeight, 1);
    var elementArea = Math.max(rect.width * rect.height, 1);

    return rect.width <= 260 && rect.height <= 260 && elementArea / viewportArea <= 0.2;
  }

  function isCandidateFloatingWidget(el) {
    var style;
    var zIndex;
    var rect;
    var anchoredToEdge;

    if (!el || el.nodeType !== 1 || isAllowed(el)) {
      return false;
    }

    if (el.matches(KNOWN_WIDGETS) || el.closest(KNOWN_WIDGETS)) {
      return true;
    }

    style = window.getComputedStyle(el);

    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }

    /*
      No ocultamos elementos con position: sticky de forma genérica.
      En páginas de producto, Prestige usa .Product__Info como sticky para
      la columna de variantes y compra; ocultarla hacía desaparecer la parte
      derecha del PDP al abrir menú/carrito en desktop.
    */
    if (style.position !== 'fixed') {
      return false;
    }

    zIndex = parseInt(style.zIndex, 10);

    if (window.isNaN(zIndex)) {
      zIndex = 0;
    }

    rect = el.getBoundingClientRect();

    if (!rect.width && !rect.height) {
      return false;
    }

    anchoredToEdge =
      rect.left <= 40 ||
      rect.top <= 40 ||
      (window.innerWidth - rect.right) <= 40 ||
      (window.innerHeight - rect.bottom) <= 40;

    return anchoredToEdge && (zIndex >= 100 || isSmallFloatingElement(rect));
  }

  function clearWidgetMarks() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-kdk-hide-while-drawer-open]'),
      function (el) {
        el.removeAttribute('data-kdk-hide-while-drawer-open');
      }
    );
  }

  function saveInlineState(el) {
    if (forcedInlineState.has(el)) {
      return forcedInlineState.get(el);
    }

    var state = {
      display: el.style.getPropertyValue('display'),
      displayPriority: el.style.getPropertyPriority('display'),
      visibility: el.style.getPropertyValue('visibility'),
      visibilityPriority: el.style.getPropertyPriority('visibility'),
      opacity: el.style.getPropertyValue('opacity'),
      opacityPriority: el.style.getPropertyPriority('opacity'),
      pointerEvents: el.style.getPropertyValue('pointer-events'),
      pointerEventsPriority: el.style.getPropertyPriority('pointer-events'),
      hadHiddenAttribute: el.hasAttribute('hidden'),
      popoverWasOpen: isPopoverOpen(el)
    };

    forcedInlineState.set(el, state);
    return state;
  }

  function restoreInlineProperty(el, propertyName, value, priority) {
    if (value) {
      el.style.setProperty(propertyName, value, priority || '');
    } else {
      el.style.removeProperty(propertyName);
    }
  }

  function forceHideInline(el) {
    if (!el || el.nodeType !== 1 || isAllowed(el)) {
      return;
    }

    saveInlineState(el);

    el.setAttribute('data-kdk-force-hide-while-drawer-open', 'true');
    el.setAttribute('hidden', 'hidden');
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');

    if (typeof el.hidePopover === 'function') {
      try {
        el.hidePopover();
      } catch (error) {
        /* noop */
      }
    }

    if (forcedHiddenElements.indexOf(el) === -1) {
      forcedHiddenElements.push(el);
    }
  }

  function restoreForcedHiddenWidgets() {
    forcedHiddenElements.slice().forEach(function (el) {
      var state;

      if (!el || el.nodeType !== 1) {
        return;
      }

      state = forcedInlineState.get(el);

      if (state) {
        restoreInlineProperty(el, 'display', state.display, state.displayPriority);
        restoreInlineProperty(el, 'visibility', state.visibility, state.visibilityPriority);
        restoreInlineProperty(el, 'opacity', state.opacity, state.opacityPriority);
        restoreInlineProperty(el, 'pointer-events', state.pointerEvents, state.pointerEventsPriority);

        if (state.hadHiddenAttribute) {
          el.setAttribute('hidden', 'hidden');
        } else {
          el.removeAttribute('hidden');
        }

        if (state.popoverWasOpen && typeof el.showPopover === 'function') {
          try {
            el.showPopover();
          } catch (error) {
            /* noop */
          }
        }

        forcedInlineState.delete(el);
      } else {
        el.removeAttribute('hidden');
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('opacity');
        el.style.removeProperty('pointer-events');
      }

      el.removeAttribute('data-kdk-force-hide-while-drawer-open');
    });

    forcedHiddenElements = [];
  }

  function markFloatingWidgets() {
    Array.prototype.forEach.call(document.body.querySelectorAll('*'), function (el) {
      if (isCandidateFloatingWidget(el)) {
        el.setAttribute('data-kdk-hide-while-drawer-open', 'true');
        forceHideInline(el);
      }
    });

    Array.prototype.forEach.call(
      document.querySelectorAll(KNOWN_WIDGETS + ', body > iframe'),
      function (el) {
        if (!isAllowed(el)) {
          el.setAttribute('data-kdk-hide-while-drawer-open', 'true');
          forceHideInline(el);
        }
      }
    );
  }

  function forceHideConsentmoShadowWidgets(host) {
    var shadowRoot;

    if (!host || !host.shadowRoot) {
      return;
    }

    shadowRoot = host.shadowRoot;

    Array.prototype.forEach.call(shadowRoot.querySelectorAll(CONSENTMO_SELECTORS), function (el) {
      forceHideInline(el);
    });
  }

  function forceHideKnownWidgets() {
    Array.prototype.forEach.call(document.querySelectorAll(KNOWN_WIDGETS), function (el) {
      if (isAllowed(el)) {
        return;
      }

      forceHideInline(el);
      forceHideConsentmoShadowWidgets(el);
    });
  }

  function startBodyObserver() {
    if (bodyObserver) {
      return;
    }

    bodyObserver = new MutationObserver(function () {
      scheduleScan();
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function stopBodyObserver() {
    if (!bodyObserver) {
      return;
    }

    bodyObserver.disconnect();
    bodyObserver = null;
  }

  function bindDrawerObserver() {
    var drawerNodes = document.querySelectorAll('#sidebar-menu, #sidebar-cart');

    if (!drawerNodes.length) {
      return;
    }

    if (drawerObserver) {
      drawerObserver.disconnect();
    }

    drawerObserver = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden';
      });

      if (shouldRun) {
        scheduleScan();
      }
    });

    Array.prototype.forEach.call(drawerNodes, function (node) {
      drawerObserver.observe(node, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    });
  }

  function bindUiStateObserver() {
    if (uiStateObserver) {
      return;
    }

    uiStateObserver = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (mutation) {
        return mutation.type === 'attributes' &&
          mutation.attributeName === 'class';
      });

      if (shouldRun) {
        scheduleScan();
      }
    });

    uiStateObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function scan() {
    bindDrawerObserver();
    bindUiStateObserver();
    clearWidgetMarks();

    var root = document.documentElement;
    var drawerOpen = prestigeDrawerIsOpen();
    var blockingOpen = blockingUiIsOpen();

    /* data-kdk-drawer-open conserva su significado original: solo drawers.
       Así no elevamos PageOverlay por encima de los diálogos nativos. */
    if (drawerOpen) {
      root.setAttribute('data-kdk-drawer-open', 'true');
    } else {
      root.removeAttribute('data-kdk-drawer-open');
    }

    if (blockingOpen) {
      root.setAttribute(BLOCKING_UI_ATTRIBUTE, 'true');
    } else {
      root.removeAttribute(BLOCKING_UI_ATTRIBUTE);
    }

    if (!blockingOpen) {
      stopBodyObserver();
      restoreForcedHiddenWidgets();
      return;
    }

    startBodyObserver();
    markFloatingWidgets();
    forceHideKnownWidgets();
  }

  function init() {
    bindDrawerObserver();
    bindUiStateObserver();
    scheduleScan();

    document.addEventListener(
      'click',
      function () {
        window.setTimeout(scheduleScan, 0);
        window.setTimeout(scheduleScan, 250);
      },
      true
    );

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape') {
        window.setTimeout(scheduleScan, 0);
        window.setTimeout(scheduleScan, 250);
      }
    });

    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(bindDrawerObserver, 0);
      window.setTimeout(scheduleScan, 0);
    });

    document.addEventListener('kdk:native:overlay', function () {
      window.setTimeout(scheduleScan, 0);
      window.setTimeout(scheduleScan, 100);
    });

    window.addEventListener('resize', scheduleScan, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
